import React, { memo, useState } from 'react'
import { Modal, ScrollView, Text, Dimensions, View, ViewStyle, Platform } from 'react-native'
import { color } from '../../theme'
import { Button } from '../button'

const height = Dimensions.get('window').height * 0.4 + 5

export const AppModal = (props: {
  visible: boolean
  onDismiss: () => void
  title: string
  titleTextStyle?: any
  bodyContainerStyle?: any
  footerContainerStyle?: any
  children: any
  onReject?: () => void
}) => {
  const {
    visible,
    onDismiss,
    title,
    titleTextStyle,
    bodyContainerStyle,
    footerContainerStyle,
    onReject,
    children,
  } = props

  const [screenHeight, setScreenHeight] = useState(0)

  const onContentSizeChange = (contentWidth: number, contentHeight: number) => {
    setScreenHeight(contentHeight)
  }

  return (
    <Modal visible={visible} transparent>
      <View style={MODAL}>
        <View style={CONTAINER}>
          <View style={TITLE_CONTAINER}>
            <Text style={{ fontSize: 16, fontWeight: 'bold', ...titleTextStyle }}>{title}</Text>
          </View>
          <ScrollView
            scrollEnabled={screenHeight > height}
            style={{
              ...BODY_CONTAINER,
              ...bodyContainerStyle,
              maxHeight: screenHeight < height ? screenHeight : height,
            }}
            contentContainerStyle={SCROLLVIEW_CONTAINER_STYLE}
            onContentSizeChange={onContentSizeChange}
          >
            {children}
          </ScrollView>
          <View
            style={{
              ...FOOTER_CONTAINER,
              ...footerContainerStyle,
            }}
          >
            {onReject && (
              <Button
                variant="outlined"
                textStyle={{ color: color.red }}
                style={{ borderColor: color.red, flex: 1 }}
                tx="Common.reject"
                onPress={onReject}
              />
            )}
            <Button style={{ flex: 1 }} tx="Common.accept" onPress={onDismiss} />
          </View>
        </View>
      </View>
    </Modal>
  )
}

const MODAL: ViewStyle = {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0,0,0,0.5)',
}

const CONTAINER: ViewStyle = {
  marginLeft: 20,
  width: Platform.OS === 'web' ? 575 : Dimensions.get('screen').width - 40,
  marginRight: 20,
  borderRadius: 20,
  padding: 20,
  justifyContent: 'center',
  alignSelf: 'center',
  alignContent: 'center',
  alignItems: 'center',
  backgroundColor: '#FFF',
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.25,
  shadowRadius: 3.84,
  elevation: 5,
}

const TITLE_CONTAINER: ViewStyle = {
  marginBottom: 15,
}

const SCROLLVIEW_CONTAINER_STYLE: ViewStyle = {
  marginRight: 10,
  marginLeft: 5,
}

const BODY_CONTAINER: ViewStyle = {
  paddingBottom: 20,
}
const FOOTER_CONTAINER: ViewStyle = {
  paddingTop: 20,
  display: 'flex',
  flexDirection: 'row',
  gap: 20,
}
